module.exports = __webpack_public_path__ + "img/app_value.8493bbc6.svg";